import { render, staticRenderFns } from "./banned-words.vue?vue&type=template&id=6ccd338e"
import script from "./banned-words.vue?vue&type=script&lang=ts"
export * from "./banned-words.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports